<div class="plans-and-pricing-container">
  <div class="plans-and-pricing-container-wrapper w-100">
    <div class="heading">
      {{translationLabels['plans_and_planning.title']}}
    </div>
    <div class="product-list">
      <ng-container *ngFor="let product of constructedProducts">
        <div class="product-info">
          <div class="product-info-wrapper">
            <div class="title">{{product.title}}</div>
            <div>{{product.description}}</div>
            <ng-container *ngFor="let ratePlan of product.ratePlansOptions">
              <div class="ratePlan-div">
                {{ ratePlan['label'] }} , {{translationLabels['plans_and_planning.plus_taxes']}}
              </div>
            </ng-container>
            <space-btn *ngIf="isSession" variant="btn1" class="btn-action" (clickEvent)="navigateToProduct()">
              {{ translationLabels['plans_and_planning.select_vehicle'] }}</space-btn>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>